import { render } from "./BaseImg.vue?vue&type=template&id=91280264"
import script from "./BaseImg.vue?vue&type=script&lang=ts"
export * from "./BaseImg.vue?vue&type=script&lang=ts"
script.render = render

export default script